// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IPublicMyHomeV1GetFlatNumberSuggestRequest,
  TPublicMyHomeV1GetFlatNumberSuggestModel,
  IMappers,
  TPublicMyHomeV1GetFlatNumberSuggestResponse,
  IPublicMyHomeV1GetFlatNumberSuggestResponse,
  IPublicMyHomeV1GetFlatNumberSuggestResponseError,
} from './types';

export const defaultConfig: TPublicMyHomeV1GetFlatNumberSuggestModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'price-estimator',
  pathApi: '/my-home/v1/get-flat-number-suggest/',
} as TPublicMyHomeV1GetFlatNumberSuggestModel;

export function createPublicMyHomeV1GetFlatNumberSuggestModel(
  parameters: IPublicMyHomeV1GetFlatNumberSuggestRequest,
): TPublicMyHomeV1GetFlatNumberSuggestModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IPublicMyHomeV1GetFlatNumberSuggestOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IPublicMyHomeV1GetFlatNumberSuggestRequest;
}

export async function fetchPublicMyHomeV1GetFlatNumberSuggest<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublicMyHomeV1GetFlatNumberSuggestOptions<TResponse200, TResponse400>): Promise<
  TPublicMyHomeV1GetFlatNumberSuggestResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(
    createPublicMyHomeV1GetFlatNumberSuggestModel(parameters),
    config,
  );
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IPublicMyHomeV1GetFlatNumberSuggestResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IPublicMyHomeV1GetFlatNumberSuggestResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TPublicMyHomeV1GetFlatNumberSuggestResponse;
}
